// extracted by mini-css-extract-plugin
module.exports = {"main":"Router_main__2QF6u","fallback":"Router_fallback__1Alf0"};